import * as I18n from 'i18n-js';
import * as React from 'react';
import SocialLink from '../../shared/social_link';
import constants from '../../shared/constants';
import SanitizedRender from '@reverbdotcom/commons/dist/components/sanitized_render';
import SaleSearchBar from '../sale_search_bar';
import { Location } from 'history';
import { get } from 'lodash';

const moment = require('moment');

const { ENDED, NOT_STARTED, TIME_EXPIRED } = constants.SALE_BUYER_INELGIBILITY_REASONS;

const SELLER = 'seller';
const CUSTOM = 'custom';
const DATE_FORMAT = 'MMMM Do';
const TIME_FORMAT = 'h:mm a';

interface Sale {
  buyer_ineligibility_reason?: string;
  discount_code: string;
  discount_percent: number;
  ends_at: string;
  live: boolean;
  sale_type: string;
  shop_name: string;
  shop_slug: string;
  show_code: boolean;
  starts_at: string;
}

interface Props {
  sale: Sale;
  description?: string;
  socialLinks: any;
  location: Location;
}

export default class SaleInformation extends React.Component<Props, null> {
  get shopHref() {
    return `/shop/${this.props.sale.shop_slug}`;
  }

  dateTimeStringFor(dateTime) {
    const parsed = moment(dateTime);
    const date = parsed.format(DATE_FORMAT);
    const time = parsed.format(TIME_FORMAT);

    return I18n.t(
      'discovery.saleInformation.dateAndTime',
      { date, time },
    );
  }

  linkFor(target) {
    const shareTarget = `share_${target}`;

    return get(
      this.props,
      `socialLinks.${shareTarget}.href`,
    );
  }

  get dateInfo() {
    const sale = this.props.sale;

    if (sale.buyer_ineligibility_reason === ENDED ||
        sale.buyer_ineligibility_reason === TIME_EXPIRED) {

      return I18n.t(
        'discovery.saleInformation.saleEnded',
        { dateTime: this.dateTimeStringFor(sale.ends_at) },
      );
    }

    if (sale.buyer_ineligibility_reason === NOT_STARTED) {
      return I18n.t(
        'discovery.saleInformation.saleBegins',
        { dateTime: this.dateTimeStringFor(sale.starts_at) },
      );
    }

    if (sale.live && !sale.buyer_ineligibility_reason) {
      return I18n.t(
        'discovery.saleInformation.saleEnds',
        { dateTime: this.dateTimeStringFor(sale.ends_at) },
      );
    }

    return null;
  }

  get discountText() {
    if (this.props.sale.show_code) {
      return I18n.t(
        'discovery.saleInformation.discount',
        { percent: this.props.sale.discount_percent, code: this.props.sale.discount_code },
      );
    }

    return I18n.t(
      'discovery.saleInformation.discount_without_code',
      { percent: this.props.sale.discount_percent },
    );
  }

  renderDate() {
    const dateInfo = this.dateInfo;
    if (!dateInfo) { return null; }

    return <SanitizedRender html={this.dateInfo} />;
  }

  renderSafeDescription() {
    if (!this.props.description) { return null; }
    if (this.props.sale.sale_type === CUSTOM) { return null; }

    return (
      <SanitizedRender
        className="sale-information__description"
        html={this.props.description}
      />
    );
  }

  renderDangerousDescription() {
    if (!this.props.description) { return null; }
    if (this.props.sale.sale_type !== CUSTOM) { return null; }

    return (
      <div
        className="sale-information__landing"
        dangerouslySetInnerHTML={{ __html: this.props.description }}
      >
      </div>
    );
  }

  renderShopInfo() {
    if (this.props.sale.sale_type !== SELLER) { return false; }

    return (
      <div className="sale-information__fineprint__shop-info">
        {I18n.t('discovery.saleInformation.createdBy')}
        <b><a href={this.shopHref}>{this.props.sale.shop_name}</a></b>
      </div>
    );
  }

  render() {
    if (!this.props.sale) { return null; }

    return (
      <aside className="sale-information">
        <div className="sale-information__inner">
          <div className="sale-information__details">
            <div className="sale-information__discount">
              <SanitizedRender html={this.discountText} />
            </div>
            <div className="sale-information__fineprint__date-info">
              {this.renderDate()}
            </div>
            {this.renderSafeDescription()}
          </div>
          <div className="sale-information__fineprint">
            <SaleSearchBar
              placeholder={I18n.t('discovery.saleInformation.searchPrompt')}
              location={this.props.location}
            />
            <aside className="sale-information__fineprint__social">
              <SocialLink link={this.linkFor('facebook')} type="facebook" />
              <SocialLink link={this.linkFor('twitter')} type="twitter" />
              <SocialLink link={this.linkFor('pinterest')} type="pinterest" />
              <SocialLink link={this.linkFor('email')} type="email" icon="envelope" />
            </aside>
            {this.renderShopInfo()}
          </div>
        </div>
        {this.renderDangerousDescription()}
      </aside>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/sales/sale_information.tsx